import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { Checkbox } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import * as api from "../../api/index.js";
import {
  DateFormatCell,
  AmountFormatCell,
  CreditAmountFormatCell,
  DebitAmountFormatCell,
  formatDateForAPI,
} from "components/common/formatter";
import { NominalTypeFormat } from "components/common/nominalTypeFormatter";
import { useLocation } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { useAllNominals, getNominalBalances } from "services/nominalsService";
import ViewPostingDetails from "../Postings/PostingDetails.jsx";
import NominalBalances from "./NominalBalances";
import Icon from "components/Global/icon";
import styles from "./nominal.module.scss";

import DocumentViewer from "components/common/DocumentViewer";
import InfoBox from "components/Global/InfoBox.jsx";
import { RedirectCell, GRID_PAGE_SIZES } from "components/common/GridComponents.jsx";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import previousIcon from "assets/previous-icon.png";
import { useCompany } from "services/companyService.js";
import { DateRange } from "components/common/DateRange.jsx";
import { getNominalRef } from "services/postingTypesService";
import PreviousTransactionsDialog from "components/common/PreviousTransactions/PreviousTransactions.jsx";
import DocumentIconCounter from "components/common/DocumentIconCounter.jsx";

const NominalLedger = () => {
  const [fileData, setFileData] = useState([]);
  const [visible1, setVisible1] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [isSearched, setIsSearched] = useState(false);
  const [transNo, settransNo] = useState("");
  const [selectedNominal, setSelectedNominal] = useState(null);
  const [activenominalRefList, setActivenominalRefList] = useState([]);
  const [showForm, setshowForm] = useState(false);
  // Using navigation state instead of Redux currentNominalRef
  const [nominalBalancesData, setNominalBalancesData] = useState(null);
  const [showPrevTrans, setShowPrevTrans] = useState(false);

  const [list, setLists] = useState({
    data: [],
    total: 0,
  });

  const [IncludeReversals, setIncludeReversals] = useState(false);
  const [dataState, setDataState] = useState({
    take: 200,
    skip: 0,
  });

  const { data: company } = useCompany();
  const date = new Date();
  let yearsStartDate = new Date(
    company.yearStartDate === undefined ? date : company.yearStartDate
  );

  const [fromDate, setFromDate] = useState(formatDateForAPI(yearsStartDate));
  const [fromDateSelector, setFromDateSelector] = useState(yearsStartDate);
  const [toDate, setToDate] = useState(formatDateForAPI(date));
  const [toDateSelector, setToDateSelector] = useState(date);
  const [searchNominalComboRef, setSearchNominalComboRef] = useState(null);
  const [nominalRefdata, setNominalRefData] = useState();

  const { data: allNominals } = useAllNominals();
  const location = useLocation();
  const selectedNominalFromNav = location.state?.selectedNominal;

  useEffect(() => {
    if (allNominals?.length > 0) {
      setActivenominalRefList(allNominals);
      setNominalRefData(allNominals.slice());
    }
  }, [allNominals]);

  const filterData = (filter) => {
    const datas = activenominalRefList.slice();
    return filterBy(datas, filter);
  };

  const onFilterChange = (event) => {
    setNominalRefData(filterData(event.filter));
  };
  const nominalGetter = (nominalRef) => {
    return (
      activenominalRefList.find((item) => item.nominalRef === nominalRef) ||
      null
    );
  };

  const changeNominalRef = (event) => {
    const value = event?.value;
    setSearchNominalComboRef(value);
    setSelectedNominal(value);
    const searchedVal = value?.nominalRef || null;
    setSearchValue(searchedVal);

    if (value) {
      setIsSearched(true);
    } else {
      setLists({ data: [], total: 0 });
      setNominalBalancesData(null);
    }
  };

  const loadPostings = async (stateOverride) => {
    if (!fromDate || !toDate || !searchValue) return;

    const state = stateOverride ?? dataState;
    const page = Math.floor(state.skip / state.take) + 1;

    try {
      const res = await getNominalRef(
        page,
        state.take,
        searchValue,
        IncludeReversals,
        fromDate,
        toDate
      );

      const result = res.data?.data || [];
      setLists({
        data: result,
        total: res.data?.total || result.length,
      });

      const balanceResult = await getNominalBalances(
        searchValue,
        fromDate,
        toDate
      );
      if (balanceResult.success) {
        setNominalBalancesData(balanceResult.data);
      }
    } catch (err) { }
  };

  useEffect(() => {
    loadPostings();
  }, [searchValue, fromDate, toDate, dataState, IncludeReversals]);

  const handleAction = (transNo) => {
    settransNo(transNo);
    setshowForm(true);
  };

  const RefCell = (e) => (
    <td
      style={{ cursor: "pointer" }}
      onClick={() => handleAction(e.dataItem.transactionNo)}
    >
      <u>{e.dataItem.reference}</u>
    </td>
  );

  const Redirect = (props) => (
    <RedirectCell
      handleClick={() => handleAction(props.dataItem.transactionNo)}
    />
  );

  const refreshData = async () => {
    const resetState = { take: 200, skip: 0 };
    setDataState(resetState);
    setIsSearched(true);
    await loadPostings(resetState);
  };

  const postingDoc = async (transNo) => {
    try {
      const { data } = await api.getPostingDocuments(transNo);
      setFileData(data.data);
      setVisible1(true);
    } catch (error) { }
  };

  const DocumentCounterCell = (e) => {
    return (
      <td>
        <DocumentIconCounter
          count={e.dataItem.documentCount}
          onClick={() => postingDoc(e.dataItem.transactionNo)}
        />
      </td>
    );
  };



  useEffect(() => {
    if (!selectedNominalFromNav || activenominalRefList.length === 0) return;

    const ref = nominalGetter(selectedNominalFromNav.nominalRef);
    if (ref) {
      changeNominalRef({ value: ref });
    }
  }, [selectedNominalFromNav, activenominalRefList]);

  const renderGrid = () => (
    <Grid
      data={list.data}
      pageable={{
        buttonCount: 5,
        pageSizes: GRID_PAGE_SIZES,
        previousNext: true,
      }}
      skip={dataState.skip}
      take={dataState.take}
      total={list.total}
      onDataStateChange={(e) => setDataState(e.dataState)}
      className="h-100 overflow-auto"
    >
      <GridToolbar>
        <button
          className="btn p-0 d-flex align-items-center justify-content-center border-0"
          onClick={() => setShowPrevTrans(true)}
          disabled={!searchNominalComboRef}
          title="Previous Transactions"
        >
          <div className={styles["dark-background"]}>
            <img src={previousIcon} width={15} height={15} alt="previous" />
          </div>
        </button>
      </GridToolbar>
      <GridColumn
        field="date"
        title="Date"
        width="110px"
        cell={DateFormatCell}
      />
      <GridColumn field="postingType" title="Type" width="60px" />
      <GridColumn field="reference" title="Ref" cell={RefCell} width="120px" />
      <GridColumn field="matterRef" title="Matter" width="100px" className="fs-sm" />
      <GridColumn field="details" title="Details" />
      <GridColumn field="transactionPeriod" title="Period" width="80px" />
      <GridColumn
        field="grossAmount"
        title="Debit"
        className="debitCol"
        cell={DebitAmountFormatCell}
        width="120px"
        headerClassName="grid-header-center"
      />
      <GridColumn
        field="grossAmount"
        title="Credit"
        className="creditCol"
        cell={CreditAmountFormatCell}
        width="120px"
        headerClassName="grid-header-center"
      />
      <GridColumn
        field="balance"
        title="Balance"
        className="balanceCol balanceTd"
        cell={AmountFormatCell}
        width="140px"
        headerClassName="grid-header-center"
      />
      <GridColumn
        field="documentCount"
        title="Doc"
        width="60px"
        cell={DocumentCounterCell}
        headerClassName="grid-header-center"
      />
      <GridColumn width="50px" cell={Redirect} />
    </Grid>
  );

  return (
    <div className="page h-100 d-flex flex-column">
      {visible1 && (
        <DocumentViewer data={fileData} onClose={() => setVisible1(false)} />
      )}

      <div
        className={`d-flex flex-wrap align-items-start justify-content-between gap-3 w-100`}
      >
        <div>
          <div className="d-flex flex-wrap align-items-start">
            <span className="mt-2 me-3">Nominal Ref</span>

            <div className="ms-0">
              {nominalRefdata && (
                <ComboBox
                  iconClassName="wa"
                  icon={<Icon icon="arrow-down" />}
                  data={nominalRefdata}
                  textField={"display"}
                  filterable={true}
                  onFilterChange={onFilterChange}
                  placeholder={"Search Nominal Ref"}
                  value={searchNominalComboRef}
                  onChange={changeNominalRef}
                  style={{ width: "300px" }}
                />
              )}
              <div style={{ height: "10px" }}>
                <InfoBox
                  className="mt-2 w-100"
                  text={
                    selectedNominal &&
                    `${NominalTypeFormat(
                      selectedNominal?.type
                    )} - ${NominalTypeFormat(selectedNominal?.subType)}`
                  }
                  title="Type"
                />
              </div>
            </div>

            <div className="ms-3">
              <Button
                className="common-btn"
                svgIcon={refreshIcon}
                onClick={refreshData}
              >
                Refresh
              </Button>
            </div>
          </div>

          <div className={`d-flex flex-wrap gap-5 align-items-end mt-4`}>
            <DateRange
              fromDate={fromDateSelector}
              toDate={toDateSelector}
              onDateChange={(newFromDate, newToDate) => {
                setFromDateSelector(newFromDate);
                setFromDate(newFromDate ? formatDateForAPI(newFromDate) : null);

                setToDateSelector(newToDate);
                setToDate(newToDate ? formatDateForAPI(newToDate) : null);
              }}
              yearStartDate={company?.yearStartDate}
            />

            <div className="d-flex align-items-center mb-2">
              <Checkbox
                checked={IncludeReversals}
                onChange={() => setIncludeReversals(!IncludeReversals)}
                label={"Show Reversed"}
              />
            </div>
          </div>
        </div>

        <div className="float-end align-items-end mt-2 mt-lg-0 d-none d-xl-block">
          <NominalBalances
            type={"NominalLedger"}
            nominal={searchNominalComboRef}
            balancesData={nominalBalancesData}
          />
        </div>
      </div>

      {showForm && (
        <ViewPostingDetails
          reloadData={refreshData}
          transNo={transNo}
          openingFrom="NominalLedger"
          cancelEdit={() => {
            setshowForm(false);
          }}
        />
      )}

      <div className="flex-grow-1 overflow-auto mt-3">{renderGrid()}</div>

      {showPrevTrans && (
        <PreviousTransactionsDialog
          isOpen={showPrevTrans}
          onClose={() => setShowPrevTrans(false)}
          entity={searchNominalComboRef}
          entityType="nominal"
        />
      )}
    </div>
  );
};

export default NominalLedger;
